import { type FC } from 'react';
import type { NodeProps } from 'reactflow';
import type { NodeData } from '@/types/node.types';
import BaseNode from './BaseNode';

const VISION_COLOR = '#8B5CF6';

export const VisionNode: FC<NodeProps<NodeData>> = ({ id, data, selected }) => {
  return <BaseNode id={id} data={data} color={VISION_COLOR} icon={'\u2605'} selected={selected} />;
};

export default VisionNode;
